import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'Components/Grid';
import CallToAction from 'Components/CallToAction';
import styles from './styles.scss';
import classNames from 'classnames/bind';
import { getGivenBackground } from 'Utils/getColor/index';
import { tabTypes } from 'Utils/getContactTab';
import ConsumptionData from 'Components/ConsumptionData';

const cx = classNames.bind(styles);

export default class SingleButton extends React.Component {
  static propTypes = {
    id: PropTypes.number,
    title: PropTypes.string,
    text: PropTypes.string,
    headline: PropTypes.string,
    trackingPushCode: PropTypes.string,
    cta1: PropTypes.shape({
      additional: PropTypes.string,
      href: PropTypes.string,
      label: PropTypes.string.isRequired,
      mazdaForm: PropTypes.bool,
      model: PropTypes.string,
      type: PropTypes.oneOf(tabTypes),
      target: PropTypes.string,
    }),
    buttonstyle: PropTypes.string,
    background: PropTypes.string,
    align: PropTypes.oneOf(['top', 'bottom', 'center']),
  };

  static defaultProps = {
    target: null,
    headline: '',
    text: '',
  };

  renderCta = (cta) => {
    const { buttonstyle, onOpenContact, title, trackingPushCode } = this.props;

    return (
      <div className={styles.cta}>
        <CallToAction
          {...cta}
          buttonType={buttonstyle}
          label={cta.label ? cta.label : title}
          onOpenContact={onOpenContact}
          trackingPushCode={trackingPushCode}
        />
      </div>
    );
  };

  render() {
    const { headline, cta1, align, background, text, consumptionText } = this.props;
    const containerClass = cx('container', `direction--${align}`, {
      [background]: true,
      black: background === getGivenBackground('black'),
    });

    return (
      <Fragment>
        <div className={containerClass}>
          <Container>
            <Row>
              <Col cols={12} m={12}>
                {headline && <h3>{headline}</h3>}
                {cta1 && this.renderCta(cta1)}
                {text && (
                  <div className={styles.pt10}>
                    <p dangerouslySetInnerHTML={{ __html: text }} />
                  </div>
                )}
              </Col>
            </Row>
          </Container>
          {consumptionText && (
            <ConsumptionData consumptionText={[consumptionText]} colorType="white" />
          )}
        </div>
      </Fragment>
    );
  }
}
